module.exports = __webpack_public_path__ + "static/img/li8_1.4425b2cb.png";